const Error = () => {
    return (
        <div>
            <h3>404 Error</h3>
            <p>cannot find page</p>
        </div>
    );
};

export default Error;
